// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { getCurrentSiteIdKey } from "../../../app/localStorageKeys"

export type StorageWriter = (payload: Slice.SetCurrentSiteIdPayload) => void

export const persist: StorageWriter = ({ userId, siteId }) => {
  localStorage.setItem(getCurrentSiteIdKey(userId), siteId)
}

export const persistCurrentSiteId = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setCurrentSiteId.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.currentSiteIdPersisted()),
        catchError(_ => of(Actions.currentSiteIdPersistFailed())),
      )),
    )

export default persistCurrentSiteId(persist)

